import type { components } from "./generated/types";

type ErrorBody = components["schemas"]["ErrorBody"];

export class WardkeyAPIError extends Error {
  readonly code: string;
  readonly status: number;
  readonly requestId: string | null;
  readonly details: unknown;

  constructor(args: {
    code: string;
    message: string;
    status: number;
    requestId: string | null;
    details?: unknown;
  }) {
    super(args.message);
    this.name = "WardkeyAPIError";
    this.code = args.code;
    this.status = args.status;
    this.requestId = args.requestId;
    this.details = args.details;
  }
}

export function isErrorBody(value: unknown): value is ErrorBody {
  if (typeof value !== "object" || value === null) return false;
  const err = (value as { error?: unknown }).error;
  if (typeof err !== "object" || err === null) return false;
  const { code, message } = err as { code?: unknown; message?: unknown };
  return typeof code === "string" && typeof message === "string";
}

export function toAPIError(
  body: unknown,
  status: number,
  requestId: string | null,
): WardkeyAPIError {
  if (isErrorBody(body)) {
    return new WardkeyAPIError({
      code: body.error.code,
      message: body.error.message,
      status,
      requestId,
      details: body.error.details,
    });
  }
  return new WardkeyAPIError({
    code: status >= 500 ? "internal_error" : "unknown_error",
    message: typeof body === "string" && body.length > 0 ? body : `HTTP ${status}`,
    status,
    requestId,
  });
}
